import { render } from "./Join.vue?vue&type=template&id=04496cb3&scoped=true"
const script = {}

import "./Join.vue?vue&type=style&index=0&id=04496cb3&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04496cb3"]])

export default __exports__